import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";

import React from "react";

const PasswordChecker = ({ isUpper, isLower, isLength, isSymbol,isNumber }) => {
  return (
    <div className="h-full flex items-center">
      <ul className="font-semibold text-sm">
        <li className="flex items-center gap-1">
          {isUpper ? (
            <AiOutlineCheck color="green" className="h-4 w-4" />
          ) : (
            <AiOutlineClose color="red" className="h-4 w-4" />
          )}{" "}
          1 Upper case
        </li>
        <li className="flex items-center gap-1">
          {isLower ? (
            <AiOutlineCheck color="green" className="h-4 w-4" />
          ) : (
            <AiOutlineClose color="red" className="h-4 w-4" />
          )}{" "}
          1 Lower case
        </li>
        <li className="flex items-center gap-1">
          {isSymbol ? (
            <AiOutlineCheck color="green" className="h-4 w-4" />
          ) : (
            <AiOutlineClose color="red" className="h-4 w-4" />
          )}{" "}
          1 Symbol
        </li>
        <li className="flex items-center gap-1">
          {isNumber ? (
            <AiOutlineCheck color="green" className="h-4 w-4" />
          ) : (
            <AiOutlineClose color="red" className="h-4 w-4" />
          )}{" "}
          1 Number
        </li>
        <li className="flex items-center gap-1">
          {isLength ? (
            <AiOutlineCheck color="green" className="h-4 w-4" />
          ) : (
            <AiOutlineClose color="red" className="h-4 w-4" />
          )}{" "}
          Min 8 Character
        </li>
      </ul>
    </div>
  );
};

export default PasswordChecker;
